module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Ic-Jb.ab00fa2c.png";